var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalStepsImg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 1.92053V10.5455",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9165 23.0038H10.5415",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 44.0872V35.4622",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0835 23.0038H35.4585",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 23.0039C7.6665 27.0705 9.28198 30.9706 12.1575 33.8462C15.0331 36.7217 18.9332 38.3372 22.9998 38.3372C27.0665 38.3372 30.9666 36.7217 33.8421 33.8462C36.7177 30.9706 38.3332 27.0705 38.3332 23.0039C38.3332 18.9372 36.7177 15.0371 33.8421 12.1616C30.9666 9.286 27.0665 7.67053 22.9998 7.67053C18.9332 7.67053 15.0331 9.286 12.1575 12.1616C9.28198 15.0371 7.6665 18.9372 7.6665 23.0039Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 17.2538V15.3372",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8752 17.25H21.9786C21.3814 17.2504 20.803 17.4586 20.3425 17.8389C19.8821 18.2191 19.5683 18.7477 19.4549 19.3341C19.3416 19.9204 19.4358 20.5279 19.7214 21.0523C20.007 21.5768 20.4662 21.9855 21.0202 22.2084L24.9762 23.7897C25.5315 24.0118 25.992 24.4204 26.2785 24.9453C26.5651 25.4702 26.6598 26.0786 26.5464 26.6658C26.4329 27.2529 26.1184 27.7822 25.657 28.1626C25.1955 28.543 24.6159 28.7507 24.0179 28.75H20.1252",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 30.6705V28.7538",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalStepsImg1);
export default __webpack_public_path__ + "static/media/legalStepsImg1.0672717aaf3d55b416b524c24b1b48a8.svg";
export { ForwardRef as ReactComponent };